export default {
  body: {
    cmpt: {
      type: 'CWelcome'
    }
  }
}
